<template>

    <div id="device-list" @created="onCreated" @updated="onUpdated" @deleted="onDeleted">

        <slot></slot>

    </div>
    
</template>

<script>

    import Device from './Device'

    export default {
        name: "device-list",
        components: {
            'device': Device,
        },
        created() {
            this.$on('created', this.onCreated);
            this.$on('updated', this.onUpdated);
            this.$on('deleted', this.onDeleted);

            $("#device-list").append("<device related-with=\"tester\" related-id=\"29\"></device>");
        },
        methods: {
            onCreated(device_id) {

            },
            onUpdated(device_id) {

            },
            onDeleted(device_id) {

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/DeviceList.vue